// orfin: Quick shipment (koszyk) — odświeżanie po zmianie koszyka.
// Blok q-s w koszyku może leżeć poza fragmentami, które base cart.js odświeża
// AJAX-em (.js-contents / .cart__footer__js-contents). Po usunięciu/zmianie
// pozycji jego widoczność (all_quick liczone serwerowo z metafieldu) nie była
// przeliczana. Ten element nasłuchuje eventu afterUpdateQuantity (emitowanego
// przez base cart.js), pobiera ?section_id sekcji koszyka, wyłuskuje SWÓJ
// odpowiednik z odpowiedzi i podmienia własną zawartość. Liczy serwer => zawsze
// zgodne z metafieldem custom.quick_shipment (też dla przyszłych ręcznych wyjątków).
if (!customElements.get('orfin-qs-cart')) {
  customElements.define(
    'orfin-qs-cart',
    class extends HTMLElement {
      connectedCallback() {
        this.sectionId = this.dataset.sectionId;
        this.blockId = this.dataset.blockId;
        this.onUpdate = this.onUpdate.bind(this);
        document.addEventListener('afterUpdateQuantity', this.onUpdate);
      }

      disconnectedCallback() {
        document.removeEventListener('afterUpdateQuantity', this.onUpdate);
      }

      async onUpdate() {
        if (!this.sectionId) return;
        try {
          const res = await fetch(`${window.location.pathname}?section_id=${this.sectionId}`);
          if (!res.ok) return;
          const html = await res.text();
          const doc = new DOMParser().parseFromString(html, 'text/html');
          // dopasuj ten sam blok (po block-id), z fallbackiem na pierwszy orfin-qs-cart
          const fresh =
            doc.querySelector(`orfin-qs-cart[data-block-id="${this.blockId}"]`) ||
            doc.querySelector('orfin-qs-cart');
          const newInner = fresh ? fresh.innerHTML : '';
          if (this.innerHTML.trim() !== newInner.trim()) {
            this.innerHTML = newInner;
          }
        } catch (e) {
          // sieć/parsing — zostaw bieżący stan, brak twardego błędu dla klienta
        }
      }
    }
  );
}
